import React from 'react';
import Avatar from '@mui/material/Avatar';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { getNameInitials } from '@/utils/constants';

const WIDTH = '1.25em';
const FONT_SIZE = '0.75em';

const BrokerAvatar = ({
	broker,
	width = WIDTH,
	height = WIDTH,
	fontSize = FONT_SIZE,
	...params
}) => {
	const { id, userId, firstName, lastName, email, name } = broker ?? {};
	const { sx, ...props } = params ?? {};

	const fullName = firstName ? `${firstName} ${lastName}` : name ? name : email;

	// The broker's Firestore user doc id: `id` on user docs/refs, `userId` on userDetails.
	const brokerUserId = id ?? userId;
	const { data } = useGetUserDetailsQuery(
		{ ...(brokerUserId ? { userId: brokerUserId } : { email }) },
		{ skip: !brokerUserId && !email },
	);

	return (
		<Avatar
			{...(data?.imageUrl && { src: data?.imageUrl })}
			sx={{
				width,
				height,
				...(sx ?? {}),
			}}
			{...props}
		>
			{!data?.imageUrl && (
				<span
					style={{
						fontSize,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
					}}
				>
					{getNameInitials(fullName ?? 'N A')}
				</span>
			)}
		</Avatar>
	);
};

export default BrokerAvatar;
